(() => {
  const polishLocale = document.documentElement.lang.toLowerCase().startsWith('pl');

  if (!polishLocale) return;

  const copy = {
    title: 'Dbamy o Twoją prywatność',
    body:
      'Używamy plików cookie razem z Shopify, aby sklep działał sprawnie, analizować ruch i lepiej dopasowywać reklamy. Ty decydujesz, na co się zgadzasz. Szczegóły znajdziesz w ',
    policyLink: 'Polityce prywatności',
    accept: 'Akceptuję wszystkie',
    decline: 'Tylko niezbędne',
    manage: 'Dostosuj ustawienia',
  };

  const updateButtonText = (button, text) => {
    if (!button) return;

    const textContainer = button.querySelector('span') || button;
    if (textContainer.textContent.trim() !== text) textContainer.textContent = text;
  };

  const updateBannerCopy = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;

    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const body = banner.querySelector('.shopify-pc__banner__body p');
    const policyLink = banner.querySelector('#shopify-pc__banner__body-policy-link');

    if (title && title.textContent.trim() !== copy.title) title.textContent = copy.title;

    if (body && policyLink) {
      const currentBodyCopy = [...body.childNodes]
        .filter((node) => node !== policyLink)
        .map((node) => node.textContent)
        .join('')
        .trim();

      if (currentBodyCopy !== copy.body.trim()) {
        [...body.childNodes].forEach((node) => {
          if (node !== policyLink) node.remove();
        });
        body.insertBefore(document.createTextNode(copy.body), policyLink);
      }

      if (policyLink.textContent.trim() !== copy.policyLink) policyLink.textContent = copy.policyLink;
    }

    updateButtonText(banner.querySelector('#shopify-pc__banner__btn-accept'), copy.accept);
    updateButtonText(banner.querySelector('#shopify-pc__banner__btn-decline'), copy.decline);
    updateButtonText(banner.querySelector('#shopify-pc__banner__btn-manage-prefs'), copy.manage);

    return true;
  };

  if (updateBannerCopy()) return;

  const observer = new MutationObserver(() => {
    if (updateBannerCopy()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();
